import { AbstractControl, AsyncValidatorFn, FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function registerFormGroup(
  group: FormGroup,
  formGroupName: string,
  formGroupConfig: { [key: string]: any[] },
  validators?: Array<ValidatorFn>,
  asyncValidators?: Array<AsyncValidatorFn>,
): AbstractControl | null {
  const subGroup = <FormGroup>group?.get(formGroupName) || new FormGroup({}, validators || [], asyncValidators || []);

  for (const key in formGroupConfig) {
    // eslint-disable-next-line no-prototype-builtins
    if (formGroupConfig.hasOwnProperty(key)) {
      subGroup.registerControl(
        key,
        new FormControl(formGroupConfig[key].shift(), (formGroupConfig[key].shift() as Array<ValidatorFn>) || []),
      );
    }
  }
  group?.addControl(formGroupName, subGroup);

  return group?.get(formGroupName);
}
